import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';
import { CTitle, STitle } from '../../components/Widget';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import { useUpdateComponentState } from '../../../hooks';

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
  });

  const updateComponentState = useUpdateComponentState();
  const startPlay = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    next += 1;
    setState({ play: next, isPlayed: true });
    updateComponentState(p_course, p_topic, ID, 'education-ot-section1-1');
    if (next <= 6) {
      setTimeout(() => startPlay(next), 1000);
    }
  };
  return (
    <>
      <div className="topic-section-1">
        <CTitle title={paragraphsSettings?.title} />
        <div id="education-ot-section1-1" className="attentions-container">
          <STitle title={paragraphsSettings?.l1} />
          <div className="content" onClick={() => startPlay()}>
            <div
              className="tip"
              dangerouslySetInnerHTML={{ __html: paragraphsSettings?.l2 }}
            />
            <div
              className="arrow"
              style={{ display: state.isPlayed ? 'none' : 'block' }}
            >
              <img src={ArrowImg} alt="" />
            </div>
            <div className="item-wrap">
              {paragraphsSettings?.l10?.map(
                (item: { no: string; desc: string }, index: number) => (
                  <div
                    key={item.no}
                    className={`attention-item ${
                      state.play > index + 1 ? 'fade-in' : ''
                    }`}
                  >
                    <div className="item-no">
                      <span>{item.no}</span>
                    </div>
                    <div className="item-desc">{item.desc}</div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section1;
